export const productConstants = {
  GET_PRODUCTS_AUTOCOMPLETE: "GET_PRODUCTS_AUTOCOMPLETE",
  SET_PRODUCTS_AUTOCOMPLETE: "SET_PRODUCTS_AUTOCOMPLETE",
};
